import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const ticketService = {};

ticketService.listTicketTypes = () => {
  return fetchV2({
    url: `${env.API_MSP}/ticket-type`,
    method: "get",
  });
};

ticketService.listTicketStatus = () => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/list-status`,
    method: "get",
  });
};

ticketService.listTickets = ({ params }) => {
  const columnFilter = params?.columnFilter || {};

  return fetchV2({
    url: `${env.API_MSP}/ticket`,
    method: "get",
    params: {
      ...columnFilter,
      page: params?.page || 1,
      "per-page": params?.sizePerPage || 10,
      sort: params?.sort || "-maker_date",
      keywords: params?.keywords || "",
      expand: params?.expand || "maker,hub,order,creator,approver,assignees,resources",
    },
  });
};

ticketService.searchTicketByCode = code => {
  return fetchV2({
    url: `${env.API_MSP}/ticket`,
    method: "get",
    params: {
      "filter[code]": code,
    },
  });
};

ticketService.createTicket = data => {
  return fetchV2({
    url: `${env.API_MSP}/ticket`,
    method: "post",
    data,
  });
};

ticketService.detailTicket = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/${ticketId}`,
    method: "get",
    params: {
      expand: "maker,hub,order,creator,approver,assignees,resources",
    },
  });
};

ticketService.ticketHistory = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket-history/${ticketId}`,
    method: "get",
  });
};

ticketService.uploadTicketResource = formData => {
  return fetchV2({
    url: `${env.API_MSP}/ticket-resource/upload-file`,
    method: "post",
    data: formData,
  });
};

ticketService.getTicketResourcePreviewBlob = ({ resourceId }) => {
  const id = resourceId != null && resourceId !== "" ? String(resourceId).trim() : "";
  return fetchV2({
    url: `${env.API_MSP}/ticket-resource/preview/${id}`,
    method: "get",
    responseType: "blob",
  });
};

ticketService.getTicketResourcePreviewArrayBuffer = ({ resourceId }) => {
  const id = resourceId != null && resourceId !== "" ? String(resourceId).trim() : "";
  return fetchV2({
    url: `${env.API_MSP}/ticket-resource/preview/${id}`,
    method: "get",
    responseType: "arraybuffer",
  });
};

ticketService.getTicketResourcePreviewJson = ({ resourceId }) => {
  const id = resourceId != null && resourceId !== "" ? String(resourceId).trim() : "";
  return fetchV2({
    url: `${env.API_MSP}/ticket-resource/preview/${id}`,
    method: "get",
  });
};

ticketService.skipTicket = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/skip`,
    method: "post",
    data: {
      ticket_id: ticketId,
    },
  });
};

ticketService.cancelTicket = ({ ticket_code, note }) => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/cancel`,
    method: "post",
    data: {
      ticket_code: String(ticket_code ?? "").trim(),
      note: String(note ?? "").trim(),
    },
  });
};

ticketService.lockTicket = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/lock`,
    method: "post",
    data: {
      ticket_id: ticketId,
    },
  });
};

ticketService.startProcessingTicket = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/${ticketId}/start-processing`,
    method: "post",
  });
};

ticketService.respondTicket = (ticketId, body = {}) => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/${ticketId}/respond`,
    method: "post",
    data: body,
  });
};

ticketService.sendToSale = data => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/send-to-sale`,
    method: "post",
    data,
  });
};

ticketService.completeTicket = ticketId => {
  return fetchV2({
    url: `${env.API_MSP}/ticket/${ticketId}/complete`,
    method: "post",
  });
};

export default ticketService;
